import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const BarsIcon = createIcon(
  'Bars',
  <path d="M6,20 L6,20 C7.1,20 8,19.1 8,18 L8,11 C8,9.9 7.1,9 6,9 L6,9 C4.9,9 4,9.9 4,11 L4,18 C4,19.1 4.9,20 6,20 Z M16,15 L16,18 C16,19.1 16.9,20 18,20 L18,20 C19.1,20 20,19.1 20,18 L20,15 C20,13.9 19.1,13 18,13 L18,13 C16.9,13 16,13.9 16,15 Z M12,20 L12,20 C13.1,20 14,19.1 14,18 L14,6 C14,4.9 13.1,4 12,4 L12,4 C10.9,4 10,4.9 10,6 L10,18 C10,19.1 10.9,20 12,20 Z" />
);

export default BarsIcon;
